import { changeHash } from "../../utils/dom";
import shared from "../../data/js/shared";

const { emailTakenErrorMessage } = shared.login;

export interface ErrorMessageProps {
	cls: string;
	msg: string;
	showLoginLink?: boolean;
}

/**
 * ErrorMessage Component
 *
 * Displays error messages with optional login link for specific errors
 *
 * @param cls - CSS class for the error message
 * @param msg - Error message text to display
 * @param showLoginLink - Whether to show the login link (defaults to true for email taken errors)
 */
export const ErrorMessage = ({ cls, msg, showLoginLink = true }: ErrorMessageProps) => {
	const shouldShowLogin = showLoginLink && msg === emailTakenErrorMessage;

	return (
		<div className={`error-message ${cls}`} data-testid={`error-${cls}`}>
			{msg}
			{shouldShowLogin && (
				<div>
					<br />
					Did you want to{" "}
					<a
						href="#"
						tabIndex={-1}
						className="to-login-link"
						onClick={(e: React.MouseEvent) => {
							e.preventDefault();
							changeHash("");
						}}
					>
						Login
					</a>
					?
				</div>
			)}
		</div>
	);
};
